<template>
  <div>
    <!-- END lines -->

    <header class="bg-white">
      <nav class="site-nav dark js-site-navbar site-navbar-target" style="z-index: 999;">
        <div class="container">
          <div class="site-navigation">
            <a href="index.html" class="logo m-0 float-left">
              <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/mea.svg" alt="MEA Service" /> -->
              <img loading="eager" fetchpriority="high" width="126" height="51" src="https://measiteassetpublic.zohostratus.in/designFiles/mea.svg" alt="MEA Service" />
            </a>

            <ul
              class="js-clone-nav d-none d-lg-inline-block site-menu float-left"
            >
              <li><router-link to="/" class="nav-link">Home</router-link></li>
              <!-- <li class="active">
                <a href="project.html" class="nav-link">Projects</a>
              </li>
              <li><a href="#" class="nav-link">Verticals</a></li>
              <li><a href="#" class="nav-link">Methodology</a></li> -->
            </ul>

            <ul
              class="js-clone-nav d-none d-lg-inline-block site-menu float-right credential"
            >
              <li class="cta-button-group">
                <button href="#"><i class="bx bx-search"></i></button>
                <button href=""><i class="bx bx-globe"></i>EN</button>
                <button class="cta-login">Login</button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style>
</style>